export default __webpack_public_path__ + "static/media/lp_developer-08.295ee0b1.png";